// extracted by mini-css-extract-plugin
module.exports = {"AdminTables":"AdminTables_d58uk","AdminTablesTabs":"AdminTablesTabs_Ue31C","AdminTablesOperationButton":"AdminTablesOperationButton_hBcqb"};